/* eslint-disable dot-notation */
import React from 'react';
import CreateAccountPrivacyPolicyHandler from '../elements/createAccount/CreateAccountPrivacyPolicyHandler';
import ScreenContext from '../ScreenContext';
import type {SnackAction} from 'src/types/snack/SnackAction';
import type {ScreenProps} from 'src/types/Screen';
import TextInput from '../elements/AVTextInput';
import {AppDispatch, store} from 'src/redux/store';
import {PulseIndicator} from 'react-native-indicators';
import {
  Platform,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
  Linking,
  AppState,
  Dimensions,
  Image,
  Pressable,
  Text,
} from 'react-native';
import Styles from 'src/components/Styles';
import ActionsFactory from 'src/actions/ActionsFactory';
import PersistentStore from 'src/services/PersistentStoreService';
import SyncHelper from 'src/services/SyncService';
import Settings from 'src/Settings';
import AccountStore from 'src/stores/AccountStore';
import AppRoutes from 'src/AppRoutes';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import {ScreenWidth} from 'react-native-elements/dist/helpers';
import FocusAwareStatusBar from 'src/components/elements/FocusAwareStatusBar';
import UIManager from 'src/components/elements/ui/UIManager';
import DeepLinkHandler from 'src/components/elements/DeepLinkHandler';
import AVText from 'src/components/elements/AVText';
import Localized from 'src/constants/AppStrings';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import NavActions from 'src/actions/NavActions';
import Header from 'src/components/elements/Header';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {EnvironmentKey} from 'src/models/Environment';
import {RootState} from 'src/redux/store';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {
  alertError,
  confirm,
  confirmNonDismissable,
} from '../helpers/AlertHelper';
import {fetchRemoteConfig} from 'src/redux/slices/firebaseRemoteConfigSlice';
import {authStore} from 'src/init';
import {getMobileAuth0Client, getWebAuth0Client} from 'src/nativeModules/Auth0';
import Events from 'src/logging/Events';
import uuid from 'src/nativeModules/UUID';
import moment from 'moment';
import DealRepository from 'src/services/aws/DealRepository';
import {OneSignal} from 'react-native-onesignal';
import DeviceInfo from 'src/nativeModules/DeviceInfo';
import {NavigationProp} from '@react-navigation/native';
import {getDescriber} from './descriptor/DescriptorType';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import {getOnboardingDescriber} from 'src/components/screens/descriptor/onboarding/DescriptorType';
import LinearGradient from 'react-native-linear-gradient';
import RedirectLoadingScreen from './RedirectLoadingScreen';
import OtpIcon from 'src/components/img/svg/OtpIcon';
import {
  trackScreenView,
  trackUserAction,
  identifyUser,
} from 'src/config/instana';
import SafeAreaView from 'src/components/elements/SafeAreaView';
import {AccountDetails} from 'src/types/AccountDetails';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

function sessionTimeOut() {
  setTimeout(
    () =>
      alertError(Localized.Errors.login_failure, null, () => {
        ActionsFactory.getAccountActions().logout().catch();
        NavActions.resetMultiple([AppRoutes.Welcome]);
      }),
    300,
  );
}

type WelcomeProps = {
  snack?: SnackAction;
  env: EnvironmentKey;
  firebaseConfig: object;
  dispatch: AppDispatch;
  shouldAutoLogin?: boolean;
  autoLoginEmail?: string;
};

type WelcomeState = {
  fullVersion: string;
  touches: number;
  appState: string;
  autoLoginEmail?: string;
};

type SettingsModel = {
  demo: boolean;
  env: string;
  gma: boolean;
  debug: boolean;
  retry: boolean;
};

//auth0
type WelcomeAuth0Props = {
  snack?: SnackAction;
  referralId?: string;
  token: string;
  navigation?: NavigationProp<WelcomeScreen>;
};

type WelcomeAuth0State = {
  fullVersion: string;
  previousRoute?: string;
  showRedirectScreen: boolean;
  redirectMessage?: string | null;
};
//------------

let appUpdateAlertShown = false;
const {width} = Dimensions.get('screen');

const {
  getWelcomeStatusBarStyleDescriptor,
  getWelcomeViewBckGrndStyleDescriptor,
  getVersionTextDescriptor,
  getWelcomeButtonStyles,
  getPasswordLoginTextStyleDescriptor,
} = getDescriber();
function RenderRedirectScreen({message}) {
  if (Settings.isNewUI()) {
    return <RedirectLoadingScreen signInMessage={message} />;
  }
  return (
    <View style={styles.redirectBackground}>
      <PulseIndicator
        size={120}
        color={Styles.bgColor}
        style={styles.indicator}
      />
      <AVText style={styles.redirectCaption}>
        {Localized.Labels.redirect_message}
      </AVText>
    </View>
  );
}
const Wrapper =
  Platform.OS === 'web'
    ? ({children}: React.PropsWithChildren<object>) => (
        <Header title={Localized.Labels.welcome_back}>{children}</Header>
      )
    : ({children}: React.PropsWithChildren<object>) => (
        <View style={[Styles.Style.flex, {paddingBottom: Styles.Spacing.m4}]}>
          {children}
        </View>
      );
export class WelcomeScreen extends React.Component<
  WelcomeProps & WelcomeAuth0Props,
  WelcomeState & WelcomeAuth0State
> {
  password: TextInput | null;
  privacyHandler: CreateAccountPrivacyPolicyHandler | null;
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;
  REDIRECT_SCREEN_SHOW_DELAY = 500;
  declare myTimeout: NodeJS.Timeout;

  static saveSettingChanges(model: SettingsModel) {
    //TODO will move static func to EnvironmentScreen in componentWillUnmount
    // replace for this.props.saveChanges(this.state);
    ActionsFactory.getAccountActions().isDemoChanged(model.demo);
    // ActionsFactory.getAccountActions().environmentChanged(model.env);
    ActionsFactory.getAccountActions().useGmaChanged(model.gma);
    ActionsFactory.getAccountActions().isDebugChanged(model.debug);
  }

  constructor(props: WelcomeProps & WelcomeAuth0Props) {
    super(props);
    this.state = {
      touches: 0,
      fullVersion: '',
      appState: AppState.currentState,
      showRedirectScreen: false,
      autoLoginEmail: props.autoLoginEmail,
      redirectMessage: null,
    };

    this.logoPress = this.logoPress.bind(this);
    this.webLoginAuth0 = this.webLoginAuth0.bind(this);
    this.goToEnvironmentSettings = this.goToEnvironmentSettings.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  _isNoAppUpdateAlertShowing = () => !appUpdateAlertShown;

  async componentDidMount() {
    const loggedIn = await this.checkIfLoggedIn();
    FirebaseAnalytic.trackEvent('componentDidMount', 'WelcomeScreen', {
      ...this.props,
      ...this.state,
      loggedIn,
    });

    const userId = AccountStore.getAccountId?.();
    const userEmail = AccountStore.getEmail?.();
    const userName = AccountStore.getFullName?.() || 'Anonymous';
    if (userId) {
      identifyUser(userId, userEmail, userName);
    }

    // Track Welcome screen view
    trackScreenView('Welcome', {
      loggedIn: String(loggedIn),
      buildType: Settings.buildType,
    });

    if (!loggedIn && !AccountStore.isDemo()) {
      const fullVersion = await Settings.getFullDisplayVersion(Platform.OS);
      this.setState({
        fullVersion,
      });
    }
    AppState.addEventListener('change', this._handleAppStateChange);

    this.props.dispatch(fetchRemoteConfig(false));
    if (!AccountStore.isDemo() && this.props.shouldAutoLogin) {
      if (Platform.OS === 'web') {
        this.webLoginAuth0(true, 'email');
      } else {
        this.handleClick(true, 'email');
      }
    }

    if (
      !AccountStore.isDemo() &&
      !ActionsFactory.getAccountActions().didIntentionalLogout()
    ) {
      this.context.actions.showModal(
        Localized.Labels.you_were_logged_out,
        Localized.Errors.oops,
        Localized.Buttons.ok,
        Styles.Colors.PayNew.primary01,
        3,
        false,
        false,
        undefined,
        () => {
          ActionsFactory.getAccountActions().setIntentionalLogout(true);
        },
      );
    }
  }

  _handleAppStateChange = (nextAppState) => {
    switch (nextAppState) {
      case 'active':
        if (
          this._isNoAppUpdateAlertShowing() &&
          this._enableShowAlertAfterMinimized()
        ) {
          this.props.dispatch(fetchRemoteConfig(true));
        }

        break;
    }
  };

  _enableShowAlertAfterMinimized = () => Platform.OS === 'ios';

  logoPress() {
    const touches = this.state.touches + 1;
    FirebaseAnalytic.trackEvent('logoPress', 'WelcomeScreen', {
      ...this.props,
      ...this.state,
      touches,
    });
    if (touches >= 5) {
      this.setState({
        touches: 0,
      });
      this.goToEnvironmentSettings();
    } else {
      this.setState({
        touches,
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<WelcomeProps>): void {
    this.showAppUpdateAlert(prevProps);
  }

  showAppUpdateAlert = (prevProps) => {
    const firebaseConfig = this.props.firebaseConfig;
    if (
      firebaseConfig !== null &&
      prevProps.firebaseConfig !== firebaseConfig
    ) {
      if (firebaseConfig['softUpdate'] && this._isNoAppUpdateAlertShowing()) {
        appUpdateAlertShown = true;
        confirm(
          firebaseConfig['alertMessage'],
          () => {
            appUpdateAlertShown = false;
            Linking.openURL(firebaseConfig['alertUpdateActionUrl']);
            this.trackEvent('softUpdateAlertLinkClick', 'WelcomeScreen');
          },
          () => {
            appUpdateAlertShown = false;
            this.trackEvent('softUpdateAlertCloseClick', 'WelcomeScreen');
          },
          firebaseConfig['alertTitle'],
          firebaseConfig['alertCancelButtonTitle'],
          firebaseConfig['alertUpdateButtonTitle'],
        );
        this.trackEvent('softUpdateAlert', 'WelcomeScreen');
      } else {
        this.showForceUpdateAlert(firebaseConfig);
      }
    }
  };

  trackEvent(event: string, screen: string) {
    FirebaseAnalytic.trackEvent(event, screen, {
      ...this.props,
      ...this.state,
    });
  }

  showForceUpdateAlert(firebaseConfig) {
    appUpdateAlertShown = true;
    confirmNonDismissable(
      firebaseConfig['alertMessage'],
      () => {
        this.showForceUpdateAlert(firebaseConfig);
        Linking.openURL(firebaseConfig['alertUpdateActionUrl']);
        this.trackEvent('forceUpdateAlertLinkClick', 'WelcomeScreen');
      },
      firebaseConfig['alertTitle'],
      firebaseConfig['alertUpdateButtonTitle'],
    );
    this.trackEvent('forceUpdateAlert', 'WelcomeScreen');
  }

  goToEnvironmentSettings() {
    const env = this.props.env;
    FirebaseAnalytic.trackEvent('goToEnvironmentSettings', 'WelcomeScreen', {
      ...this.props,
      ...this.state,
    });
    NavActions.push(AppRoutes.Environment, {
      saveChanges: WelcomeScreen.saveSettingChanges,
      env,
      demo: AccountStore.isDemo(),
      debug: AccountStore.isDebug(),
      showRetry: Platform.OS === 'android',
      showGma: true,
      showDemo: true,
      showDebug: true,
      showLanguage: true,
      showCreateAccount: true,
      onCountrySelectionPress: this.onCountrySelectionPress,
    });
  }

  onCountrySelectionPress = () => NavActions.push(AppRoutes.CountrySelection);

  async checkIfLoggedIn() {
    const accDetail = await PersistentStore.getAccountDetails();
    const gmaAccDetails = await PersistentStore.getGmaAccountDetails();
    FirebaseAnalytic.trackEvent('checkIfLoggedIn', 'WelcomeScreen', {
      ...this.props,
      ...this.state,
      accDetail,
    });
    if (
      gmaAccDetails.accountInfo?.FirstName === undefined &&
      gmaAccDetails.accountInfo?.Email
    ) {
      return false;
    }
    if (accDetail && accDetail.accountId !== '-1' && accDetail.username) {
      this.context.actions.changeRootRoute(AppRoutes.App);
      return true;
    }

    return false;
  }

  async handleClick(isSignUp = false, connection: string) {
    // Track user action
    trackUserAction('login_click', {
      isSignUp: String(isSignUp),
      connection,
      buildType: Settings.buildType,
    });

    if (AccountStore.isDemo()) {
      this.context.actions.changeRootRoute(AppRoutes.App);
      this.setState({autoLoginEmail: undefined});
      this.context.actions.changeRootRoute(AppRoutes.App);
      return;
    }
    if (isSignUp) {
      Events.AccountSignup.trackEvent(DeviceInfo.getModel(), 'Start');
    }
    // Set timeout as 500ms
    // so that redirect screen does not appear immediately
    // this.myTimeout = setTimeout(() => {

    // }, this.REDIRECT_SCREEN_SHOW_DELAY);
    this.setState({showRedirectScreen: true});
    await new Promise((resolve) =>
      setTimeout(resolve, this.REDIRECT_SCREEN_SHOW_DELAY),
    );
    const payrollImportAuth0Data = await PersistentStore.getPayrollImportData();

    const Auth0 = getMobileAuth0Client();

    const env = store.getState().environment.env;

    try {
      const loginHint =
        this.state.autoLoginEmail ??
        (await ActionsFactory.getAccountActions().getPersistedEmail());
      const locale = Settings.getLocale();
      const country = locale.includes('-') ? locale.split('-')[1] : 'US';
      const credentials = await Auth0.webAuth.authorize(
        {
          scope: 'openid offline_access profile email',
          audience: Settings.auth0[env].audience,
          organization: Settings.auth0[env].orgIdAuth0,
          additionalParameters: {
            login_hint: loginHint ?? '',
            accountImportId: payrollImportAuth0Data?.importId ?? '',
            prompt: 'login',
            countryCode: country,
            connection: connection,
            referralId: this.props.referralId ?? '',
          },
        },
        {
          ephemeralSession: true,
        },
      );
      if (isSignUp) {
        Events.AccountSignup.trackEvent(DeviceInfo.getModel(), 'Completed', {
          audience: Settings.auth0[env].audience,
          organization: Settings.auth0[env].orgIdAuth0,
          loginHint,
        });
      }
      this.setState({
        redirectMessage: Localized.Labels.signing_you_in_now,
      });

      if (credentials) {
        await authStore.storeSession(credentials);
        await authStore.migrateCredentials();
        const {snack} = this.props;
        await this.verifyLogin(this.context, undefined, snack);
      }
    } catch (error) {
      clearInterval(this.myTimeout);
      this.setState({showRedirectScreen: false});

      const message = error?.message?.toLowerCase?.();
      const guid = await uuid.getRandomUUID();

      // Step 1: Handle known harmless cases
      if (
        message?.includes('user cancelled') ||
        message?.includes('browser window was closed')
      ) {
        if (isSignUp) {
          Events.AccountSignup.trackEvent(
            DeviceInfo.getModel(),
            'End:Cancelled',
          );
        }
        return;
      }

      // Step 2: Log everything
      CrashlyticsEvents.log(
        'Exception',
        'Login:Error',
        error?.toString(),
        guid,
      );
      Events.Error.trackEvent(
        'Exception',
        'Login:Error',
        error?.toString(),
        guid,
      );

      // Step 3: Try to parse CAUSE from error.message
      let parsedError;
      try {
        const match = error?.message?.match(/CAUSE: (.*)/);
        if (match && match[1]) {
          parsedError = JSON.parse(match[1]);
        }
      } catch (parseError) {
        Events.Error.trackEvent(
          'Exception',
          'Login:parseError',
          parseError.toString(),
          guid,
        );
      }

      // Step 4: Try fallback `error_description` parsing
      if (!parsedError && error?.error_description) {
        try {
          parsedError = JSON.parse(error.error_description);
        } catch (fallbackError) {

          parsedError = {message: error.error_description};
        }
      }

      // Step 5: Specific handling — locked account
      if (parsedError?.violation === 'Account is Locked/Disabled') {
        if (isSignUp) {
          Events.AccountSignup.trackEvent(
            DeviceInfo.getModel(),
            'End:Account is Locked/Disabled',
          );
        }
        alertError(Localized.Errors.your_account_is_locked_disabled);
        return;
      }

      if (isSignUp) {
        Events.AccountSignup.trackEvent(
          DeviceInfo.getModel(),
          'End:Unable to login at this time, please try again later.',
        );
      }

      alertError('Unable to login at this time, please try again later.');
    } finally {
      this.setState({autoLoginEmail: undefined});
    }
  }

  async webLoginAuth0(isSignUp?: boolean, connection?: string) {
    if (isSignUp) {
      Events.AccountSignup.trackEvent('Web', 'Start');
    }
    const payrollImportAuth0Web = await PersistentStore.getPayrollImportData();
    try {
      const auth0WebClient = await getWebAuth0Client();
      await auth0WebClient.loginWithPopup({
        authorizationParams: {
          accountImportId: payrollImportAuth0Web?.importId ?? '',
          prompt: 'login',
          connection: connection,
          referralId: this.props.referralId ?? '',
        },
      });
      const user = await auth0WebClient.getUser();

      if (!user) {
        return;
      }
      const accessToken = await auth0WebClient.getTokenSilently({
        detailedResponse: true,
      });
      const idInfo = await auth0WebClient.getIdTokenClaims();

      await authStore.storeSession({
        accessToken: accessToken.access_token,
        idToken: idInfo.__raw,
        expiresAt: moment().unix() + accessToken.expires_in,
        tokenType: 'Bearer',
        scope: '',
        refreshToken: 'web',
        isSSO: idInfo['https://365rm.us/isSSO'],
        isNewUser: idInfo['https://365rm.us/isNewUser'],
        hasQRCode: idInfo['https://365rm.us/hasQRCode'],
      });

      const account = await ActionsFactory.getAccountActions().loginLegacy();

      if (account.firstName === null && account.email) {
        this.context.actions.changeRootRoute(AppRoutes.Login);
        const params = {
          accountId: account.accountId,
          email: account.unverifiedEmail,
          isSSO: account.isSSO,
          firstName: account.firstName,
          lastName: account.lastName,
          showPin: !account.pinHash,
          referralId: this.props?.referralId,
          token: this.props.token,
        };

        if (isSignUp) {
          Events.AccountSignup.trackEvent('Web', 'Completed', {
            accountId: account.accountId,
            email: account.unverifiedEmail,
            isSSO: `${account.isSSO}`,
            firstName: account.firstName,
            lastName: account.lastName,
          });
        }
        NavActions.push(AppRoutes.CountrySelection, params);
        return;
      } else if (account.unverifiedEmail) {
        sessionTimeOut();
        return;
      }
      const shouldShowQRCode = await authStore.shouldShowQRCode();
      if (shouldShowQRCode) {
        NavActions.push(AppRoutes.MarketCardRegistration, {
          onSuccess: () =>
            WelcomeScreen.onLoginSuccess(
              account,
              this.context,
              this.props.referralId,
              this.props.token,
              undefined,
              this.props.snack,
            ),
        });
      } else {
        await WelcomeScreen.onLoginSuccess(
          account,
          this.context,
          this.props.referralId,
          this.props.token,
          undefined,
          this.props.snack,
        );
      }
    } catch (error) {
      let parsedError;
      try {
        const outerError =
          typeof error === 'string' ? JSON.parse(error) : error;

        if (outerError?.error_description) {
          parsedError = JSON.parse(outerError.error_description);
        }
      } catch (err) {
        Events.Error.trackEvent(
          'Exception',
          'WebLogin:parseError',
          err.toString(),
        );
      }

      if (parsedError?.violation === 'Account is Locked/Disabled') {
        isSignUp &&
          Events.AccountSignup.trackEvent(
            'Web',
            'End:Account is Locked/Disabled',
          );
        alertError(Localized.Errors.your_account_is_locked_disabled);
      }
    }
  }

  async verifyLogin(context, initialTabRoute, snack) {
    let account = await ActionsFactory.getAccountActions().loginLegacy(true);

    if (account.disabled || account.isLocked) {
      alertError(
        Localized.Errors.your_account_is_locked_disabled,
        null,
        () => {
          NavActions.reset(AppRoutes.Welcome);
          ActionsFactory.getAccountActions().logout();
        },
        Localized.Errors.uh_oh,
      );
    } else {
      account = await ActionsFactory.getAccountActions().loginLegacy();
      const shouldShowQRCode = await authStore.shouldShowQRCode();
      if (shouldShowQRCode) {
        NavActions.push(AppRoutes.MarketCardRegistration, {
          onSuccess: () =>
            WelcomeScreen.onLoginSuccess(
              account,
              context,
              initialTabRoute,
              snack,
            ),
          email: account.email,
        });
      } else {
        await WelcomeScreen.onLoginSuccess(
          account,
          context,
          initialTabRoute,
          snack,
        );
      }
    }
  }

  static async onLoginSuccess(
    account: AccountDetails,
    context: ScreenProps,
    referralId: string,
    token: string,
    initialTabRoute?: AppRoutes,
    snack?: SnackAction,
  ) {
    DealRepository.clearDeals();
    if (!AccountStore.isDemo()) {
      OneSignal.login(account.accountId);
      OneSignal.User.addTags({
        email: account.email,
        mka: account.accountId,
        locationId: account.locationId,
        env: store.getState().environment.env,
        platform: Platform.OS,
      });
    }

    if (account.accountId) {
      FirebaseAnalytic.setUserId(account.accountId, {
        accountId: account.accountId,
        email: account.email,
        unverifiedEmail: account.unverifiedEmail,
        mka: account.accountId,
        org: account.orgId,
        location: account.locationId,
        region: account.localization.region,
        city: account.city,
        zip: account.zip,
        currency: account.localization.currency,
        env: store.getState().environment.env,
        firstName: account.firstName,
        lastName: account.lastName,
        referralId: referralId,
      });
      if (Platform.OS !== 'web' && account.accountId) {
        CrashlyticsEvents.setUser(`user_${account.accountId}`, {
          email: account.email,
          region: account.localization.region,
          env: store.getState().environment.env,
        });
      }
    }

    Events.AccountLogin.trackEvent(
      DeviceInfo.getModel(),
      account.localization.region,
      account.localization.currency,
      account.isSSO,
      account.email,
    );

    if (snack) {
      context.actions.changeRootRoute(AppRoutes.App, initialTabRoute, {
        nestedNames: [AppRoutes.Inbox],
        name: AppRoutes.SnackDetail,
        params: {snackLocationId: snack.locationId, ...snack},
      });
    } else if (Platform.OS !== 'web') {
      //TODO: Follow up for information about email/unverifiedEmail
      //TODO: unverifiedEmail is null after clicking the link in the email to continue setting up account
      if (account.firstName === null && account.email) {
        NavActions.reset(AppRoutes.Welcome);
        NavActions.push(AppRoutes.CountrySelection, {
          accountId: account.accountId,
          email: account.unverifiedEmail,
          firstName: account.firstName,
          lastName: account.lastName,
          showPin: !account.pinHash,
          referralId: referralId,
          token: token,
        });
      } else if (account.unverifiedEmail) {
        sessionTimeOut();
        return;
      } else {
        context.actions.changeRootRoute(AppRoutes.App, initialTabRoute);
      }
    } else {
      context.actions.changeRootRoute(AppRoutes.App, initialTabRoute);
    }

    SyncHelper.performSyncWithServer();
    ActionsFactory.getAccountActions().refreshMessages();
  }

  close() {
    NavActions.pop();
  }

  renderImage() {
    return (
      <Image
        source={require('src/components/img/WelcomeRefiveDotOverlay.png')}
        style={getWelcomeViewBckGrndStyleDescriptor()['overlay']}
        resizeMode="cover"
      />
    );
  }

  onLinkExistingAccount = () => NavActions.push(AppRoutes.LinkExistingAccount);
  onCreateAccount = () => NavActions.push(AppRoutes.CreateAccountEnterEmail);
  checkIsRevolve = () => {
    return Styles.Colors.PayNew.primary01;
  };
  renderWelcomeView() {
    const isWebSignOn = Platform.OS === 'web';
    const isCanteen =
      Settings.buildType === BuildTypeEnum.canteen ||
      Settings.buildType === BuildTypeEnum.companykitchen;
    const isRedesignRefive =
      Settings.buildType === BuildTypeEnum.default ||
      Settings.buildType === BuildTypeEnum.refive;
    return (
      <View style={styles.welcomeView}>
        {Settings.buildType === BuildTypeEnum.aramark && (
          <AVText
            style={styles.aramarkTxtSty}
            accessible
            testID="qa_txtYei"
            nativeID="qa_txtYei"
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          >
            {getOnboardingDescriber().getWelcomeDescriptionText()}
          </AVText>
        )}

        {(isRedesignRefive || isCanteen) && (
          <AVText
            style={
              !Settings.isRefive()
                ? styles.commonDescTxtStyl
                : styles.refiveTxtSty
            }
            accessible
            testID="qa_txtYei"
            nativeID="qa_txtYei"
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          >
            {getOnboardingDescriber().getWelcomeDescriptionText()}
          </AVText>
        )}
        <View style={{marginHorizontal: Styles.Spacing.m4}}>
          <RoundedButton
            accessible={true}
            testID="qa_btnLog_In"
            accessibilityHint="Go to the login screen"
            accessibilityRole="button"
            buttonType={ButtonType.normal}
            icon={<OtpIcon fill={Styles.white} />}
            containerStyle={[
              getWelcomeButtonStyles()['topButton'],
              styles.alignStyle,
            ]}
            wrapperStyle={styles.wrapperStyle}
            textStyle={[styles.textStyleTop, {color: Styles.white}]}
            color={getOnboardingDescriber().getLoginButtonColor()}
            onPress={() =>
              isWebSignOn
                ? this.webLoginAuth0(false, 'email')
                : this.handleClick(false, 'email')
            }
            text={Localized.Buttons.log_in}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
          />

          <View style={styles.marginBtmStyle}>
            <RoundedButton
              accessibilityRole="button"
              accessible={true}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
              testID="qa_btn_Sign_Up"
              color={getOnboardingDescriber().getLoginButtonColor()}
              accessibilityHint="Sign up new account"
              icon={
                <OtpIcon
                  color={getOnboardingDescriber().getLoginButtonColor()}
                />
              }
              textStyle={[
                isCanteen ? styles.canteenText : styles.textStyle,
                {color: getOnboardingDescriber().getLoginButtonColor()},
              ]}
              text={Localized.Labels.sign_up}
              containerStyle={[
                getWelcomeButtonStyles()['topButton'],
                styles.signUpBtnContainer,
              ]}
              wrapperStyle={styles.wrapperStyle}
              onPress={() =>
                isWebSignOn
                  ? this.webLoginAuth0(true, 'email')
                  : this.handleClick(true, 'email')
              }
              buttonType={ButtonType.outline}
              backgroundColor={Styles.white}
            />
          </View>
        </View>
        <View
          style={
            Settings.buildType === BuildTypeEnum.aramark
              ? styles.loginByPasswordContainerAramark
              : styles.loginByPasswordContainer
          }
        >
          <AVText
            style={[
              Settings.buildType !== BuildTypeEnum.aramark &&
                styles.haveAccountTxt,
              getPasswordLoginTextStyleDescriptor()['passwordLoginText'],
            ]}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
            testID="qa_lnk_Log_In_Here"
            nativeID="qa_lnk_Log_In_Here"
          >
            {Localized.Labels.have_an_account + ' '}
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
              nativeID={'Btn' + Localized.Labels.log_in_here}
              onPress={() =>
                isWebSignOn
                  ? this.webLoginAuth0(false, 'Consumers')
                  : this.handleClick(false, 'Consumers')
              }
              style={[
                styles.passwordTxt,
                getPasswordLoginTextStyleDescriptor()['passwordLoginText'],
                getPasswordLoginTextStyleDescriptor()['passwordLoginTextColor'],
              ]}
              testID="qa_lnk_Log_In_Here"
            >
              {Localized.Labels.log_in_here}
            </AVText>
          </AVText>
        </View>
      </View>
    );
  }

  render() {
    const gradientProps = getOnboardingDescriber().getLogoGradientProps();

    return (
      <LinearGradient {...gradientProps} style={styles.gradientContainer}>
        <Wrapper>
          {Settings.isRefive() && (
            <View style={styles.reBGImg}>{this.renderImage()}</View>
          )}
          {!this.state.showRedirectScreen ? (
            this.renderMainContent()
          ) : (
            <View style={StyleSheet.absoluteFill}>
              <RenderRedirectScreen
                message={this.state.redirectMessage ?? ''}
              />
            </View>
          )}
        </Wrapper>
      </LinearGradient>
    );
  }

  renderMainContent() {
    return (
      <SafeAreaView
        backgroundStyle={{backgroundColor: 'none'}}
        style={
          getWelcomeViewBckGrndStyleDescriptor() &&
          getWelcomeViewBckGrndStyleDescriptor()['view']
        }
      >
        <FocusAwareStatusBar
          barStyle={UIManager.getLoginStatusBarStyle()}
          backgroundColor={getWelcomeStatusBarStyleDescriptor()}
        />
        <DeepLinkHandler
          launchAuth0Login={
            Platform.OS === 'web'
              ? this.webLoginAuth0
              : this.handleClick.bind(this)
          }
        />
        <CreateAccountPrivacyPolicyHandler
          ref={(privacyHandler) => {
            this.privacyHandler = privacyHandler;
          }}
        />
        <View style={styles.flexStyle} />
        {this.renderLogo()}
        {this.renderWelcomeContent()}

        <View style={styles.versionView}>
          <AVText
            accessible={true}
            accessibilityLabel={`Application version: ${this.state.fullVersion}`}
            style={[
              styles.versionText,
              getVersionTextDescriptor()['versionText'],
            ]}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
          >
            {this.state.fullVersion}
          </AVText>
        </View>
      </SafeAreaView>
    );
  }

  renderWelcomeContent() {
    return (
      <View style={styles.welcomeContent}>{this.renderWelcomeView()}</View>
    );
  }

  renderLogo() {
    return (
      <View style={styles.logoContainer}>
        <TouchableWithoutFeedback
          accessible={false}
          onPress={this.logoPress}
          testID="qa_logo"
        >
          <View accessible testID="qa_logo" nativeID="qa_logo">
            {getOnboardingDescriber().getLoginLogo()}
          </View>
        </TouchableWithoutFeedback>
        {Settings.buildType === BuildTypeEnum.default && (
          <AVText
            style={styles.payText}
            accessible
            testID="qa_txt365Pay"
            nativeID="qa_txt365Pay"
            accessibilityLabel={Settings.appDisplayName}
            aria-label={Settings.appDisplayName}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
          >
            365Pay
          </AVText>
        )}
        {Settings.buildType === BuildTypeEnum.canteen && (
          <AVText
            style={styles.canteenTextRedesign}
            accessible
            testID="qa_txtC&P"
            nativeID="qa_txtC&P"
            accessibilityLabel={Settings.appDisplayName}
            aria-label={Settings.appDisplayName}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
          >
            Connect & Pay
          </AVText>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  otpIcon2Color: {
    color:
      Settings.buildType === BuildTypeEnum.canteen
        ? '#003349'
        : Settings.buildType === BuildTypeEnum.default
        ? Styles.Colors.PayNew.primary01
        : Styles.Colors.PayNew.primary01,
  },
  gradientContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  view: {
    backgroundColor: Styles.darkBlueRevolveColor,
    flex: 1,
  },
  logoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 3.5,
  },
  canteenLogoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
  },
  logoContainer365Pay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
  },
  container: {
    flex: 1,
    alignItems: 'center',
  },
  content: {
    width: ScreenWidth,
  },
  welcomeContent: {
    width: Platform.OS === 'web' ? null : ScreenWidth,
  },
  lineContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: Styles.Spacing.m2,
  },
  solidLine: {
    height: 1,
    flex: 1,
    marginHorizontal: Styles.Spacing.m2,
  },
  instructionsWelcome: {
    color: Styles.black,
    fontSize: Styles.Fonts.f4,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: Styles.Spacing.m1,
  },

  instructions: {
    color: Styles.white,
    fontSize: Styles.Fonts.f4,
    fontWeight: 'bold',
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: Styles.Spacing.m3,
  },
  versionText: {
    fontSize: Styles.Fonts.f8,
    marginLeft: Styles.Spacing.m3,
  },
  indicator: {
    flex: 0.5,
  },
  redirectCaption: {
    color: Styles.bgColor,
    fontSize: Styles.Fonts.f5,
    fontWeight: '700',
    marginTop: 0,
    paddingTop: 0,
    marginStart: 8,
    marginEnd: 8,
    textAlign: 'center',
  },
  topButton: {
    marginTop: Styles.Spacing.m3,
    alignSelf: 'auto',
    paddingVertical: Styles.Spacing.m1,
  },
  createAccountButton: {
    marginTop: -13,
    alignSelf: 'auto',
    paddingVertical: Styles.Spacing.m1,
  },
  textStyleTop: {
    textAlign: 'center',
    fontSize: Styles.Fonts.f1,
    color: Styles.white,
    textTransform: 'capitalize',
  },
  textStyle: {
    textAlign: 'center',
    fontSize: Styles.Fonts.f1,
    color:
      Settings.buildType === BuildTypeEnum.canteen
        ? '#003349'
        : Settings.buildType === BuildTypeEnum.default
        ? Styles.Colors.PayNew.primary01
        : Styles.Colors.PayNew.primary01,
    textTransform:
      Settings.buildType === BuildTypeEnum.default ? 'capitalize' : 'none',
  },
  canteenText: {
    textAlign: 'center',
    fontSize: Styles.Fonts.f1,
    color: '#003349',
  },
  divider: {
    flex: 2,
    height: 2,
    marginHorizontal: Styles.Spacing.m2,
    backgroundColor: Styles.white,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  welcomeView: {},
  logoImg: {
    width: width - (width / 5.5) * 3,
    height: width - (width / 5.5) * 3,
    alignSelf: 'center',
    position: 'absolute',
    marginTop: '15%',
    zIndex: 999,
  },
  redirectBackground: {
    backgroundColor: Styles.primaryColor,
    minHeight: Styles.ScreenHeight,
    minWidth: Styles.ScreenWidth,
    alignSelf: 'center',
  },
  welcomeBackText: {
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 24,
  },
  payText: {
    color: Styles.Colors.PayNew.black01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 46,
    fontStyle: 'normal',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: Styles.Spacing.m1,
  },
  canteenTextRedesign: {
    color: Styles.Colors.PayNew.black01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 46,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 48,
    textAlign: 'center',
    marginTop: Styles.Spacing.m3,
  },
  commonDescTxtStyl: {
    marginHorizontal: Styles.Spacing.m3,
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: '700',
  },
  aramarkTxtSty: {
    marginHorizontal: Styles.Spacing.m3,
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    fontFamily: Styles.FontFamily.figtreeRegular,
    fontSize: Styles.Fonts.f7,
  },
  refiveTxtSty: {
    marginHorizontal: Styles.Spacing.m3,
    color: '#022649',
    textAlign: 'center',
    fontFamily: Styles.FontFamily.figtreeRegular,
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: '700',
  },
  alignStyle: {alignItems: 'center'},
  marginBtmStyle: {marginBottom: Styles.Spacing.m3 + Styles.Spacing.m1},
  signUpBtnContainer: {borderWidth: 2, alignItems: 'center'},
  wrapperStyle: {paddingVertical: Styles.Spacing.m0},
  haveAccountTxt: {
    color: Styles.black,
    textAlign: 'center',
  },
  passwordTxt: {
    color: Styles.Colors.PayNew.primary01,
    textDecorationColor: Styles.Colors.PayNew.primary01,
    textDecorationLine: 'underline',
  },
  reBGImg: {position: 'absolute', top: 0, bottom: 0},
  flexStyle: {flex: 1},
  versionView: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  loginByPasswordContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m4,
  },
  loginByPasswordContainerAramark: {
    marginHorizontal: Styles.Spacing.m4,
  },
});
export default compose(
  withForwardedNavigationParams<WelcomeProps>(),
  connect((state: RootState) => ({
    env: state.environment?.env,
    firebaseConfig: state.firebaseConfig?.data,
  })),
)(WelcomeScreen);
